import { UserEdit } from './UserEdit';
import UserList from './UserList';
import { PostReferenceInput } from './UserPost';

export default {
  create: PostReferenceInput,
  list: UserList,
  edit: UserEdit,
};
